import React from 'react';

export interface HorizontalSpaceProps {
  width?: number;
}

export const HorizontalSpace: React.FC<HorizontalSpaceProps> = (props) => {
  const { width = 0 } = props;

  return <div style={{ width: `${width}px` }} />;
};
